/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-08 09:26:53
 * @LastEditTime: 2019-07-24 14:01:00
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

/* 获取我的供给列表接口 */
const invitationUrl = `/website/warehousing/invitation/supplyList`

/* 邀请查看接口 */
const invitationSaveUrl = `/website/warehousing/invitation`

/* 获取地址接口 */
const getAreaUrl = `sys/sysArea/find`

/* 查询字典接口 */
const getDictUrl = `sys/dict/getDict`

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }, {}))
    }
  })
}

// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}

// 邀请查看列表
export function invitationSave(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + invitationSaveUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'save'
      }, param))
    }
  })
}

// 获取我的供给列表
export function invitationList(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + invitationUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageMySupply'
      }, param))
    }
  })
}
